var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99935 7.5026H3.74935C3.19681 7.5026 2.66691 7.28311 2.27621 6.89241C1.88551 6.50171 1.66602 5.97181 1.66602 5.41927C1.66602 4.86674 1.88551 4.33683 2.27621 3.94613C2.66691 3.55543 3.19681 3.33594 3.74935 3.33594H4.99935",
    stroke: "#CD7F32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5026H16.25C16.8025 7.5026 17.3324 7.28311 17.7231 6.89241C18.1138 6.50171 18.3333 5.97181 18.3333 5.41927C18.3333 4.86674 18.1138 4.33683 17.7231 3.94613C17.3324 3.55543 16.8025 3.33594 16.25 3.33594H15",
    stroke: "#CD7F32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 18.3359H16.6673",
    stroke: "#CD7F32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 12.2188V14.1688C8.33398 14.6271 7.94232 14.9854 7.52565 15.1771C6.54232 15.6271 5.83398 16.8688 5.83398 18.3354",
    stroke: "#CD7F32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 12.2188V14.1688C11.666 14.6271 12.0577 14.9854 12.4743 15.1771C13.4577 15.6271 14.166 16.8688 14.166 18.3354",
    stroke: "#CD7F32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66406H5V7.4974C5 8.82348 5.52678 10.0952 6.46447 11.0329C7.40215 11.9706 8.67392 12.4974 10 12.4974C11.3261 12.4974 12.5979 11.9706 13.5355 11.0329C14.4732 10.0952 15 8.82348 15 7.4974V1.66406Z",
    stroke: "#CD7F32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPlace);
export default __webpack_public_path__ + "static/media/thirdPlace.71b99b879b8d45b464a2719c78c0b75a.svg";
export { ForwardRef as ReactComponent };